import { useWorkspaceSelection } from "./WorkspaceSelectionContext";

const styles = {
  bar: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "var(--admin-gap)",
    padding: "var(--admin-control-padding-y) var(--admin-card-padding)",
    borderBottom: "1px solid var(--border)",
    background: "var(--accent-soft)",
  },
  count: { color: "var(--text-main)", fontSize: "var(--admin-text-sm)", fontWeight: 800 },
  actions: { display: "flex", alignItems: "center", gap: "var(--admin-gap-sm)", flexWrap: "wrap" },
  primary: {
    border: "none",
    borderRadius: "var(--admin-radius)",
    padding: "var(--admin-button-padding-y) var(--admin-button-padding-x)",
    background: "var(--accent)",
    color: "var(--button-text)",
    fontSize: "var(--admin-text-xs)",
    fontWeight: 800,
    cursor: "pointer",
  },
  secondary: {
    border: "1px solid var(--border-strong)",
    borderRadius: "var(--admin-radius)",
    padding: "var(--admin-button-padding-y) var(--admin-button-padding-x)",
    background: "var(--card-bg)",
    color: "var(--text-main)",
    fontSize: "var(--admin-text-xs)",
    fontWeight: 800,
    cursor: "pointer",
  },
};

export default function TemporarySelectionBar({ selectedItems, onClear, additionalActions = null }) {
  const { addItems } = useWorkspaceSelection();

  if (selectedItems.length === 0) return null;

  return (
    <div style={styles.bar}>
      <span style={styles.count}>Выбрано: {selectedItems.length}</span>
      <div style={styles.actions}>
        <button type="button" style={styles.primary} onClick={() => addItems(selectedItems)}>
          Добавить в рабочую подборку
        </button>
        {additionalActions}
        <button type="button" style={styles.secondary} onClick={onClear}>
          Снять выделение
        </button>
      </div>
    </div>
  );
}
